import React from 'react';
import Lottie from 'react-lottie';
import './ProfileUpdateLottie.css';
import * as animationData from './ProfileUpdateLottie.json';

function ProfileUpdateLottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='ProfileUpdateLottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default ProfileUpdateLottie;